if (!customElements.get('related-articles')) {
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();
      this.options = {
        slidesPerView: 1.265,
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
          clickable: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: 3,
            centerInsufficientSlides: true,
          },
        },
      };
    }

    connectedCallback() {
      const element = this.querySelector('[data-slider]');

      if (!element || !Swiper) return;

      this.slider = new Swiper(element, this.options);
    }
  }
  customElements.define('related-articles', RelatedArticles);
}
